import React, { useEffect, useState } from 'react';
import './ucheck.style.scss';
import { AuthStatus, Direction, ReduxState, VersionCheck } from 'interface';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { toast, ToastContainer } from 'react-toastify';
import { StylesProvider, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { API, RoutePath } from '../data';
import Signin from './register/signin/signin.index';
import { initUserData, uCheckInitialize } from './ucheck.scripts';
import KioskContainer from './kiosk/kiosk.index';
import { registeredId } from 'scripts/storage';
import * as Sentry from '@sentry/react';
import { Button, Modal } from 'react-bootstrap';
import { post } from 'scripts/api';
import PortalContainer from './portal/portal.index';
import ENV from 'env.json';
import { MessageBridge } from 'scripts/messageBridge';
import UCheckQuestioner from './questioner/questioner.index';

const UCheck: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang;
    const [show, setShow] = useState<boolean | 'critical'>(false);
    const [link, setLink] = useState<string>();
    const history = useHistory();
    const theme = createMuiTheme({
        direction: props.dir === Direction.rtl ? 'rtl' : 'ltr',
        palette: {
            primary: {
                light: '#634d6f',
                main: '#3c214b',
                dark: '#2a1734',
                contrastText: '#fff',
            },
            secondary: {
                light: '#64cbee',
                main: '#3ebfea',
                dark: '#2b85a3',
                contrastText: '#fff',
            },
        },
    });
    const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

    useEffect(() => {
        uCheckInitialize(props.dispatch);
        document.addEventListener('message', messageHandler);
        askPermission();
        post<VersionCheck[]>(API.version(Number(ENV.version)), {}).then((res) => {
            if (res.data.length) {
                const lastVersionID = res.data
                    .map((i) => i.id)
                    .reduce(function (a, b) {
                        return Math.max(a, b);
                    }, 0);
                const lastVersion = res.data.findIndex((i) => i.id === lastVersionID);
                setLink('https://www.ucheck.me/application');
                setShow(res.data.map((i) => i.is_critical).includes(true) ? 'critical' : true);
            }
        });

        return () => {
            document.removeEventListener('message', messageHandler);
        };
    }, []);

    function askPermission() {
        MessageBridge.request('ASK_PERMISSION_FROM_USER', {
            key: 'WRITE_EXTERNAL_STORAGE',
            title: 'درخواست دسترسی به حافظه',
            message: 'ما برای ذخیره پاسخنامه های شما به صورت دسترسی به حافظه احتیاج داریم.',
            // buttonNeutral: string,
            buttonPositive: 'تایید',
            // buttonNegative: 'عدم تایید',
        }).then((res: 'GRANTED' | 'DENIED' | 'NEVER_ASK_AGAIN') => {
            console.log('11111111111111111111', res);
            if (res !== 'GRANTED') {
                toast.error('برنامه برای کارکرد صحیح نیازمند به مجوز دسترسی به حافظه است.');
                askPermission();
            } else {
                MessageBridge.request('ASK_PERMISSION_FROM_USER', {
                    key: 'READ_EXTERNAL_STORAGE',
                    title: 'درخواست دسترسی به حافظه',
                    message: 'ما برای ذخیره پاسخنامه های شما به صورت دسترسی به حافظه احتیاج داریم.',
                    // buttonNeutral: string,
                    buttonPositive: 'تایید',
                    // buttonNegative: 'عدم تایید',
                }).then((res: 'GRANTED' | 'DENIED' | 'NEVER_ASK_AGAIN') => {
                    console.log('22222222222222222222', res);
                    if (res !== 'GRANTED') {
                        toast.error('برنامه برای کارکرد صحیح نیازمند به مجوز دسترسی به حافظه است.');
                        askPermission();
                    }
                });
            }
        });
    }

    useEffect(() => {
        if (props.isAuth === AuthStatus.valid && !props.kiosk) {
            MessageBridge.request('GET_NOTIFICATION_TOKEN').then((response: string) => {
                console.log('===============', response);
                post(API.notification.devices(), { registration_id: response, type: 'android' }).then(() => {
                    registeredId.set(response);
                });
            });
        }
        const backPressed = MessageBridge.subscribe('BACK_BUTTON_PRESSED', () => {
            if (!props.kiosk) history.goBack();
        });
        return () => {
            MessageBridge.unsubscribe(backPressed);
        };
    }, [props.isAuth, props.kiosk]);

    const messageHandler = (e) => {
        MessageBridge.onMessage(e);
    };

    useEffect(() => {
        if (props.user?.email) Sentry.setUser({ email: props.user.email });
        else Sentry.configureScope((scope) => scope.setUser(null));
    }, [props.user?.email]);

    useEffect(() => {
        if (props.isAuth === AuthStatus.valid) {
            initUserData();
        }
    }, [props.isAuth]);

    if (show === 'critical') {
        return (
            <div className="ucheck-base-page">
                <div className="critical-text d-flex align-items-center justify-content-center flex-column">
                    <p>{lang.criticalVersion}</p>
                    <a target="_blank" rel="noreferrer" href={link}>
                        <Button>{lang.download}</Button>
                    </a>
                </div>
            </div>
        );
    }

    return (
        <StylesProvider jss={jss}>
            <ThemeProvider theme={theme}>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={props.dir === Direction.rtl}
                    // pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                {show ? (
                    <Modal show={show === true} className={`ucheck-new-version`} size={'lg'} centered>
                        <i onClick={() => setShow(false)} className="material-icons close-icon">
                            close
                        </i>
                        <div className="ucheck-modal-body">
                            <p>{lang.newVersion}</p>
                            <div className="ucheck-modal-footer">
                                <a href={link} target="_blank" rel="noreferrer">
                                    <Button>{lang.download}</Button>
                                </a>
                                <Button className="cancel-button" onClick={() => setShow(false)}>
                                    {lang.cancel}
                                </Button>
                            </div>
                        </div>
                    </Modal>
                ) : null}
                {props.isAuth === AuthStatus.inValid && props.kiosk && <KioskContainer />}
                {props.isAuth === AuthStatus.inValid && props.portal && <PortalContainer />}
                <Switch>
                    {props.isAuth === AuthStatus.inValid && !(props.kiosk || props.portal) && (
                        <Switch>
                            <Route path={RoutePath.register.signIn.index} component={Signin} />
                            <Route path="*">
                                <Redirect to={RoutePath.register.signIn.index} />
                            </Route>
                        </Switch>
                    )}
                    {props.isAuth === AuthStatus.valid && !props.kiosk && <UCheckQuestioner />}
                </Switch>
            </ThemeProvider>
        </StylesProvider>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    kiosk: state.kioskData,
    portal: state.portalPublishData,
    lang: state.lang,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(UCheck);
